<template>
  <nav
    class="navbar is-primary no-print"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <!-- <img src="@/assets/logo.png" width="30" height="30"> -->
        <span>&nbsp;&nbsp;{{ this.user.username }}</span>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
        :class="{ 'is-active': isMenuActive }"
        @click="isMenuActive = !isMenuActive"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <div
          class="navbar-item has-dropdown is-hoverable"
          v-if="
            roleid == '25' || roleid == '26' || roleid == '27' || roleid == '28'
          "
        >
          <a class="navbar-link">
            <span>ວຽກງານ ICS</span>
          </a>

          <div class="navbar-dropdown">
            

            <router-link  v-if="roleid == '26' || roleid == '27' || roleid == '28' "
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/recorddistrict"
              :exact="true"
              active-class="is-active"
            >
              <span>ກວດກາປັດໃຈການຜະລິດ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/violation"
              :exact="true"
              active-class="is-active"
            >
              <span>ປະຕິບັດລະບຽບຕໍ່ຜູ້ລະເມີດ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/certification"
              :exact="true"
              active-class="is-active"
            >
              <span>ການອອກໃບຢັ້ງຢືນ</span>
            </router-link>
          </div>
        </div>

        <div
          class="navbar-item has-dropdown is-hoverable" v-if="
            roleid == '25' || roleid == '26' || roleid == '27' || roleid == '28'
          "
        >
          <a class="navbar-link">
            <span>ກວດສອບຜົນຜະລິດ</span>
          </a>

          <div class="navbar-dropdown">
            

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/groupcheckproduct"
              :exact="true"
              active-class="is-active"
            >
              <span>ກວດສອບຜົນຜະລິດເຂົ້າຕະຫຼາດ</span>
            </router-link>

          </div>
        </div>

        <div
          class="navbar-item has-dropdown is-hoverable" v-if="
            roleid == '25' || roleid == '26' || roleid == '27' || roleid == '28'
          "
        >
          <a class="navbar-link">
            <span>ລາຍງານ</span>
          </a>

          <div class="navbar-dropdown">
            

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/icsrecord"
              :exact="true"
              active-class="is-active"
            >
              <span>ລາຍງານການຜະລິດ</span>
            </router-link>

          </div>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" v-if="roleid == '25' || roleid == '26' || roleid == '27' ">
            <span>ຕັ້ງຄ່າຕ່າງໆ</span>
          </a>
          <div class="navbar-dropdown" v-if="roleid == '25'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/setting/user"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຜູ້ໃຊ້ຂັ້ນແຂວງ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/setting/province"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການແຂວງ</span>
            </router-link>
          </div>

          <div class="navbar-dropdown" v-if="roleid == '26'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/setting/user"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຜູ້ໃຊ້ຂັ້ນເມືອງ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/setting/province"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການເມືອງ</span>
            </router-link>
          </div>
          <div class="navbar-dropdown" v-if="roleid == '27'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/setting/user"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການຜູ້ໃຊ້ຂັ້ນກຸ່ມ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/ics/setting/province"
              :exact="true"
              active-class="is-active"
            >
              <span>ຈັດການກຸ່ມ</span>
            </router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <span>ຜູ້ໃຊ້ງານ</span>
          </a>
          <div class="navbar-dropdown">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/form/userProfile"
              :exact="true"
              active-class="is-active"
            >
              <span>ຂໍ້ມູນສ່ວນຕົວ</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/login"
              :exact="true"
              active-class="is-active"
            >
              <span>ອອກຈາກລະບົບ</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false,
      roleid: null,
    };
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    console.log("roleid: " + JSON.stringify(this.roleid));
  },
  computed: {
    // user: get("loginData"),
  },
  methods: {
    menuClicked() {
      this.isMenuActive = false;
    },
  },
};
</script>

<style scoped>
.navbar-item {
  white-space: nowrap;
}
.navbar-end {
  padding-right: 60px;
}
</style>
